import { keyboardOperatorSuggestionsData } from "@/components/suggestions/providers/operatorSuggestionsProvider";
import { checkFilterRules } from "@/components/suggestions/providers/utils/filterRules";

import type { SingleSuggestion } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { FilterRule } from "@corca/data";

function isSelectionRule(rule: FilterRule): boolean {
  const { condition } = rule;
  const constrainsSelection = condition.selectedNodes !== undefined;
  const dependsOnNeighbour =
    condition.nodeBefore !== undefined || condition.nodeAfter !== undefined;

  return constrainsSelection && !dependsOnNeighbour;
}

export function findSelectionApplyOperator(
  doc: DocumentModel,
  symbol: string,
): SingleSuggestion<"operator"> | undefined {
  const { index, node } = doc.cursor;
  const { selectedNodes } = doc.selection;

  const matches = keyboardOperatorSuggestionsData.filter((suggestion) => {
    const matchesSymbol = suggestion.item.symbol === symbol;
    const matchesKeyword = suggestion.item.variantKeywords?.en?.[symbol] !== undefined;

    if (!matchesSymbol && !matchesKeyword) {
      return false;
    }

    const selectionRules = suggestion.filterRules?.filter(isSelectionRule) ?? [];
    if (selectionRules.length === 0) {
      return false;
    }

    return checkFilterRules(selectionRules, { index, node, selectedNodes, selectedRequired: true });
  });

  const [match] = [...matches].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
  return match;
}
